import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(public)/not-found.tsx");
